export default "__VITE_ASSET__cfa00d47__"